export default __webpack_public_path__ + "static/media/warning-triangle.d7c003d6.svg";